import ModalityRepository from '@/shared/http/repositories/socialProject/modality'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import Modality from '@/shared/models/modality'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'EditarModalidade',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Modalidade',
    modality: new Modality(),
    isNew: false,
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Modalidades',
            href: this.$router.resolve({ name: 'Modality' }).href
          },
          {
            text: 'Editar modalidade',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getById()
  },

  methods: {
    getById() {
      loading.push()
      ModalityRepository.GetById(this.$route.params.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.modality = res.data.data
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar modalidade', 'ERRO')
        })
    },

    update(modality) {
      loading.push()
      ModalityRepository.Update(modality)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          loading.pop()
          toast.success('Modalidade editada com sucesso', 'EDITAR MODALIDADE')
          Promise.resolve()
          return this.$router.replace({ name: 'Modality' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao editar modalidade', 'ERRO')
        })
    }
  }
}
